import React from 'react'
import tankImage from "../../../images/products/D.png"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/home/p-4.jpg'

function craftPaperBag() {

 const values = [
  {
    number: 1,
    text: "Dual-layer protection – Combines natural craft paper with strong PP woven fabric.",
  },
  {
    number: 2,
    text: "Moisture resistant – Laminated surface keeps contents safe from humidity and spills.",
  },
  {
    number: 3,
    text: "Tear resistant – Reinforced design handles heavy loads and rough handling with ease.",
  },
  {
    number: 4,
    text: "Eco-friendly look – Offers a natural, brown paper finish ideal for sustainable branding.",
  },
  {
    number: 5,
    text: "Printable surface – Supports high-quality printing for brand logos, product info, or labels.",
  },
  {
    number: 6,
    text: "Food-grade safe – Suitable for packaging edible goods like flour, grains, and seeds.",
  },
  {
    number: 7,
    text: "Custom sizes available – Made to suit different packaging volumes and applications.",
  },
  {
    number: 8,
    text: "Ideal for bulk packing – Perfect for fertilizers, feed, cement, agro-products, and more.",
  },
];


  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'PP Laminated Kraft'} pagesub={'Products'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
      <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
  <h2 className="fw-bold mb-3">Natural Look. Reinforced Strength.</h2>
  <p style={{ textAlign: "justify" }}>
    PP Laminated Krafts combine the eco-friendly look of kraft paper with the strength of polypropylene. These bags are widely used for packaging agricultural, industrial, and food-grade materials, offering both durability and aesthetic appeal.
  </p>
  <p style={{ textAlign: "justify" }}>
    At SNBS, we manufacture high-quality kraft paper bags laminated with PP film for added protection. The outer paper layer gives a premium natural finish, while the inner woven fabric ensures strength, tear resistance, and moisture protection—making them suitable for heavy or sensitive materials.
  </p>
  <p style={{ textAlign: "justify" }}>
    Our PP laminated kraft paper bags are available in multiple sizes, ply combinations, and print options. They’re ideal for packing products like animal feed, seeds, flour, chemicals, and building materials—offering a perfect blend of functionality and visual impact.
  </p>
</div>

      </div>
    </section>
 {/* <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">PP Laminated Kraft</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
               PP Laminated Kraft available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
               PP Laminated Kraft Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
            <tr className="table-light">
              <th>Height (mm)</th>
              <td>1850</td>
              <td>2070</td>
              <td>2650</td>
              <td>3050</td>
            </tr>
            <tr className="table-light">
              <th>Diameter (mm)</th>
              <td>1550</td>
              <td>1870</td>
              <td>1940</td>
              <td>2120</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> */}
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default craftPaperBag